import $foreign from "./foreign.cjs";
var unsafePerformEffect = $foreign.unsafePerformEffect;
export { unsafePerformEffect };
